import { z } from 'zod';
import { get } from '../http';
import { resource } from '../schemas/common';
import { achievementRewardSchema, eliteRankEnrollmentSchema, rankSchema } from '../schemas/domain';

export const ranksApi = {
  /** Every rank across Alpha Club A, Alpha Club B and Elite, with progress. */
  list: () => get('/ranks', resource(z.array(rankSchema))),

  current: () =>
    get(
      '/ranks/current',
      resource(
        z.object({
          alpha_a: rankSchema.nullable(),
          alpha_b: rankSchema.nullable(),
          elite: rankSchema.nullable(),
          next: rankSchema.nullable(),
        }),
      ),
    ),

  achievements: () => get('/ranks/achievements', resource(z.array(achievementRewardSchema))),

  eliteEnrollment: () => get('/ranks/elite', resource(eliteRankEnrollmentSchema.nullable())),

  /* admin */
  adminList: () => get('/admin/ranks', resource(z.array(rankSchema))),
};
